import React, { createContext, useCallback, useContext, useState, ReactNode } from "react";

import { SessionAttachment } from "../types/uploads";

interface UploadedFilesContextType {
    files: SessionAttachment[];
    addFile: (file: SessionAttachment) => void;
    removeFile: (id: string) => void;
    clearFiles: () => void;
}

const UploadedFilesContext = createContext<UploadedFilesContextType | undefined>(undefined);

export const UploadedFilesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [files, setFiles] = useState<SessionAttachment[]>([]);

    const addFile = useCallback((file: SessionAttachment) => {
        setFiles(prev => {
            const withoutExisting = prev.filter(item => item.id !== file.id);
            return [...withoutExisting, file];
        });
    }, []);

    const removeFile = useCallback((id: string) => {
        setFiles(prev => prev.filter(file => file.id !== id));
    }, []);

    const clearFiles = useCallback(() => {
        setFiles([]);
    }, []);

    return (
        <UploadedFilesContext.Provider value={{ files, addFile, removeFile, clearFiles }}>
            {children}
        </UploadedFilesContext.Provider>
    );
};

export const useUploadedFiles = () => {
    const context = useContext(UploadedFilesContext);
    if (context === undefined) {
        throw new Error("useUploadedFiles must be used within an UploadedFilesProvider");
    }
    return context;
};
